// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hf","advertCardHeader__actions":"c-a_hg","advertCardHeader__bottomLabel":"c-a_hh"};